module.exports = __webpack_public_path__ + "img/switzerland-cerebrovascular-disease-female.13a2db1c.png";